import {Observable, Subject} from "rxjs/Rx";
import {Injectable} from "@angular/core";
import {ModalService} from "@digicerba/common";
import {ArticleDto, CommandeMaterielDto, ICommandeMaterielWebServiceClient} from "@resources/resources";

@Injectable()
export class PanierStore {

  private panier: CommandeMaterielDto;
  private onPanierUpdateObs: Subject<CommandeMaterielDto> = new Subject();
  private affichageRecap: boolean = false;

  constructor(private commandeMaterielWebServiceClient: ICommandeMaterielWebServiceClient,
    private modalService: ModalService) {
  }

  getPanier(): Observable<CommandeMaterielDto> {
    if (this.panier == null) {
      return this.refreshPanier();
    } else {
      return Observable.create(observer => {
        observer.next(this.panier);
        observer.complete();
      });
    }
  }

  resetPanier() {
    this.panier = new CommandeMaterielDto();
    this.panier.id = null;
  }

  refreshPanier(): Observable<CommandeMaterielDto> {
    let obs: Observable<CommandeMaterielDto> = null;
    if ((this.panier != null) && (this.panier.id != null)) {
      obs = this.commandeMaterielWebServiceClient.getCommande(this.panier.id);
    } else {
      obs = this.commandeMaterielWebServiceClient.rechercheCurrentCommande();
    }

    obs.subscribe(panier => {
      if (panier == null) {
        this.panier = new CommandeMaterielDto()
        this.panier.id = null;
      }

      if ((this.panier != null) && (this.panier.id == panier.id) && (this.panier.etat !== panier.etat)) {
        this.resetPanier();
        this.refreshPanier().subscribe(panier => {
          this.onPanierUpdateObs.next(this.panier);
        });
      }
      this.panier = panier;
      this.onPanierUpdateObs.next(this.panier);
    });

    return obs;
  }

  isPanier() {
    return this.panier && this.panier.etat && this.panier.etat != 'VALIDEE' && this.panier.etat != 'TERMINEE';
  }

  isEnCoursValidation() {
    return this.panier && this.panier.etat && this.panier.etat == 'EN_COURS_VALIDATION';
  }

  isValidee() {
    return this.panier && this.panier.etat && (this.panier.etat == 'VALIDEE' || this.panier.etat == 'TERMINEE');
  }

  isTerminee() {
    return this.panier && this.panier.etat && (this.panier.etat == 'VALIDEE' || this.panier.etat == 'TERMINEE');
  }

  isAffichargeRecap() {
    return this.affichageRecap;
  }

  resetAffichageRecap() {
    this.affichageRecap = false;
  }

  countPanierArticles() {
    let count: number = 0;
    if (this.isPanier() && this.panier.lignes) {
      for (var index = 0; index < this.panier.lignes.length; index++) {
        count += this.panier.lignes[index].quantite;
      }
    }
    return count;
  }

  onPanierUpdate(): Observable<CommandeMaterielDto> {
    return this.onPanierUpdateObs.asObservable();
  }

  addItem(articleId: number, quantite: number): Observable<CommandeMaterielDto> {
    if (this.panier.etat == 'VALIDEE') {
      this.resetPanier();
      return Observable.create(observer => {
        this.refreshPanier().subscribe(result => {
          this.addItemToPanier(articleId, quantite).subscribe((result) => {
            observer.next(result);
            observer.complete();
          });
        });
      });
    } else {
      return this.addItemToPanier(articleId, quantite);
    }
  }

  addItemToPanier(articleId: number, quantite: number): Observable<CommandeMaterielDto> {
    let date = null;
    if (this.panier) {
      date = this.panier.dateModification;
    }

    let article = new ArticleDto();
    article.id = articleId;

    let observable = this.commandeMaterielWebServiceClient.addLigneCommande(this.panier.id, {
      id: null,
      quantite: quantite,
      article: article
    }, { dateModification: date });

    observable.subscribe(result => {
      this.panier = result;
      this.onPanierUpdateObs.next(this.panier);

    }, error => {
      console.log("Erreur add item");
      if (error.status == 422) {
        this.panierHasChange(error);
      }
    });
    return observable;
  }

  updateQuantite(ligneCommandeId, quantite: number) {
    let date = null;
    if (this.panier) {
      date = this.panier.dateModification;
    }
    this.commandeMaterielWebServiceClient.updateQuantiteLigneCommande(ligneCommandeId, quantite, { dateModification: date }).subscribe(result => {
      this.panier = result;
      this.onPanierUpdateObs.next(this.panier);
    }, error => {
      console.log("Erreur update quantité");
      if (error.status == 422) {
        this.panierHasChange(error);
      }
    });
  }

  deleteItem(ligneCommandeId) {
    let date = null;
    if (this.panier) {
      date = this.panier.dateModification;
    }

    this.commandeMaterielWebServiceClient.deleteLigneCommande(ligneCommandeId, { dateModification: date }).subscribe(result => {
      this.panier = result;
      this.onPanierUpdateObs.next(this.panier);
    }, error => {
      console.log("Erreur delete item");
      if (error.status == 422) {
        this.panierHasChange(error);
      }
    });
  }

  validateCommande() {
    let date = null;
    if (this.panier) {
      date = this.panier.dateModification;
    }
    this.commandeMaterielWebServiceClient.validateCurrentCommande(this.panier.id, { dateModification: date }).subscribe(result => {
      this.panier = result;
      this.onPanierUpdateObs.next(this.panier);
      this.affichageRecap = true;
    }, error => {
      console.log("Erreur validate panier");
      if (error.status == 422) {
        this.panierHasChange(error);
      }
    });
  }

  private panierHasChange(error) {
    if (error != null) {
      if (error.json().message.indexOf("quota") > -1) {
        this.modalService.openInfoDialog("MODAL.QUOTA.title", "MODAL.QUOTA.message", "MODAL.QUOTA.confirm").onDialogClose().subscribe(() => {
          this.resetAffichageRecap();
          this.refreshPanier().subscribe(panier => {
            this.onPanierUpdateObs.next(this.panier);
          });
        })
      } else if (error.json().message.indexOf("désactivé") != -1) {
        this.modalService.openInfoDialog("MODAL.DESACTIVATION.title", "MODAL.DESACTIVATION.message", "MODAL.DESACTIVATION.confirm").onDialogClose().subscribe(() => {
          this.resetAffichageRecap();
          this.refreshPanier().subscribe(panier => {
            this.onPanierUpdateObs.next(this.panier);
          })
        });
      } else {
        this.modalService.openInfoDialog("MODAL.ACTUALISER.title", "MODAL.ACTUALISER.message", "MODAL.ACTUALISER.confirm").onDialogClose().subscribe(() => {
          this.resetAffichageRecap();
          this.refreshPanier().subscribe(panier => {
            this.onPanierUpdateObs.next(this.panier);
          });
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/common/store/panier.store.ts